var _circle, _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaylighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1128_62)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5491 39.4836C48.0318 40.7722 47.617 41.8348 47.6274 41.8449C47.6378 41.855 47.8571 41.8232 48.1148 41.7742C48.7579 41.6518 50.2499 41.6505 50.9182 41.7717C51.1776 41.8187 51.3974 41.8498 51.4066 41.8409C51.4294 41.8186 49.5466 37.1403 49.5149 37.1406C49.5011 37.1407 49.0664 38.1951 48.5491 39.4836ZM43.9251 38.3821C43.9251 38.6516 44.1916 41.6881 44.2171 41.7085C44.2994 41.7747 45.8093 42.1947 45.8407 42.1601C45.9003 42.0943 46.4519 40.6749 46.4345 40.632C46.4254 40.6095 45.9065 40.1292 45.2816 39.5646C43.9699 38.3798 43.9251 38.3408 43.9251 38.3821ZM53.8206 39.4765C53.1559 40.0837 52.6045 40.6012 52.5954 40.6267C52.5779 40.6752 53.1281 42.093 53.1912 42.1621C53.2249 42.199 54.7361 41.7771 54.8104 41.7101C54.8286 41.6938 54.8911 41.0176 54.9493 40.2075C55.0074 39.3974 55.0665 38.6518 55.0805 38.5505C55.0945 38.4493 55.0887 38.3678 55.0676 38.3695C55.0465 38.3712 54.4853 38.8694 53.8206 39.4765ZM39.5115 41.9253C39.5322 41.9778 41.3202 45.0172 42.0491 46.2388C42.0627 46.2617 42.1724 46.1006 42.2929 45.8809C42.7447 45.0565 43.386 44.2636 44.0624 43.6931C44.2865 43.5042 44.4651 43.3448 44.4594 43.339C44.445 43.3244 39.5448 41.8522 39.5105 41.8522C39.4953 41.8522 39.4957 41.8851 39.5115 41.9253ZM57.0064 42.5996L54.5521 43.3413L54.7655 43.5124C55.48 44.0852 56.2589 45.0186 56.723 45.8579C56.8513 46.09 56.9674 46.2613 56.9809 46.2385C57.7295 44.9834 59.4976 41.9779 59.5183 41.9253C59.5341 41.8851 59.5276 41.8535 59.5039 41.855C59.4802 41.8566 58.3563 42.1917 57.0064 42.5996ZM38.6346 46.6123C37.7881 46.7406 37.069 46.8543 37.0365 46.865C37.0039 46.8757 37.6152 47.3084 38.3949 47.8265L39.8126 48.7684L40.5313 48.2938L41.25 47.8192L41.1583 47.671C41.1079 47.5895 40.9148 47.2632 40.7291 46.9459C40.4557 46.4785 40.3709 46.37 40.2825 46.3741C40.2225 46.3768 39.4809 46.484 38.6346 46.6123ZM58.3007 46.9459C58.1151 47.2632 57.9224 47.589 57.8725 47.67L57.7818 47.8173L58.4954 48.2903L59.209 48.7632L60.6386 47.8127C61.4249 47.2898 62.0368 46.8524 61.9983 46.8406C61.9049 46.8119 58.8274 46.369 58.7213 46.369C58.668 46.369 58.5174 46.5755 58.3007 46.9459ZM39.1324 51.0026C37.9505 51.7886 36.9909 52.4391 37.0001 52.4479C37.0226 52.4699 41.9082 53.1908 42.0436 53.1922C42.147 53.1933 42.1436 53.1761 41.9575 52.7552C41.6068 51.9623 41.3903 51.0591 41.3195 50.0945L41.2813 49.5733L39.1324 51.0026ZM57.7046 50.1059C57.6455 51.0528 57.3946 52.0731 57.0256 52.8666C56.882 53.1751 56.8792 53.1933 56.9733 53.1933C57.1143 53.1933 61.7475 52.5152 61.9168 52.4698C62.0687 52.429 62.3418 52.6215 58.7511 50.238L57.7382 49.5656L57.7046 50.1059ZM40.3279 55.9962C39.8648 56.7818 39.4969 57.4352 39.5104 57.4483C39.5377 57.4749 42.6725 56.5404 42.7243 56.4901C42.7668 56.4489 42.8898 54.8679 42.8533 54.8322C42.829 54.8085 41.3704 54.573 41.2256 54.5694C41.1949 54.5686 40.791 55.2107 40.3279 55.9962ZM56.9502 54.6921C56.5389 54.7554 56.1903 54.8189 56.1756 54.8332C56.147 54.861 56.2604 56.4444 56.2934 56.4785C56.3226 56.5087 59.5466 57.4712 59.5621 57.4544C59.5695 57.4466 59.1951 56.7994 58.7302 56.0163C58.1302 55.0058 57.8577 54.5903 57.7915 54.5848C57.7402 54.5805 57.3616 54.6289 56.9502 54.6921ZM44.3072 56.004C44.2744 56.164 43.9228 60.9154 43.9424 60.9345C43.96 60.9517 47.7177 57.567 47.7414 57.5126C47.7492 57.4947 47.6019 57.4401 47.414 57.3914C46.5264 57.1609 45.5275 56.7022 44.7906 56.1865C44.5603 56.0254 44.3624 55.8936 44.3509 55.8936C44.3394 55.8936 44.3197 55.9432 44.3072 56.004ZM54.5752 55.9438C54.512 56.0436 53.6552 56.5746 53.1898 56.8025C52.6791 57.0526 51.9696 57.3157 51.5419 57.4138C51.3965 57.4471 51.2792 57.4888 51.2814 57.5064C51.2866 57.5485 55.0686 60.9529 55.0886 60.9335C55.1075 60.9151 54.7543 56.1587 54.7226 56.004C54.6987 55.8877 54.6289 55.8592 54.5752 55.9438ZM48.9348 58.4514C48.6307 58.7241 48.3523 58.9746 48.3162 59.0081C48.2626 59.0578 48.363 59.3486 48.8613 60.5866C49.1973 61.4212 49.4882 62.1204 49.5078 62.1402C49.5274 62.16 49.8236 61.4789 50.1659 60.6266C50.7747 59.111 50.7862 59.0751 50.693 58.9874C50.3449 58.6604 49.5419 57.9556 49.5174 57.9556C49.501 57.9556 49.2389 58.1787 48.9348 58.4514Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1128_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6741 41.5162C45.2115 41.9496 42.3906 44.2146 41.2975 47.4391C40.9464 48.4749 40.8682 48.9869 40.8682 50.2476C40.8682 51.5083 40.9464 52.0204 41.2975 53.0561C42.7809 57.4322 47.424 59.9113 51.9164 58.7257C55.122 57.8798 57.5694 55.2534 58.2795 51.8972C58.4627 51.0315 58.4462 49.3725 58.2455 48.4714C57.4264 44.7932 54.5863 42.1273 50.8908 41.5677C50.3184 41.4809 49.1692 41.4543 48.6741 41.5162Z",
    fill: "#393184"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1128_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 37.7366L54.2092 25V75.9464H72V37.7366Z",
    fill: "url(#paint1_linear_1128_62)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 37.7366L54.2092 25V75.9464H72V37.7366Z",
    stroke: "url(#paint2_linear_1128_62)",
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1128_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 37.7366L45.7908 25V75.9464H28V37.7366Z",
    fill: "url(#paint3_linear_1128_62)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 37.7366L45.7908 25V75.9464H28V37.7366Z",
    stroke: "url(#paint4_linear_1128_62)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1128_62",
    x: 38.9682,
    y: 39.5824,
    width: 21.3391,
    height: 21.3391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1128_62",
    x: 52.059,
    y: 22.6137,
    width: 22.091,
    height: 55.4836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1128_62",
    x: 25.85,
    y: 22.6137,
    width: 22.091,
    height: 55.4836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_62",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_62",
    x1: 70.0962,
    y1: 29.7004,
    x2: 46.516,
    y2: 33.9641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_62",
    x1: 61.622,
    y1: 33.4911,
    x2: 35.7828,
    y2: 54.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1128_62",
    x1: 29.9038,
    y1: 29.7004,
    x2: 53.484,
    y2: 33.9641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1128_62",
    x1: 38.378,
    y1: 33.4911,
    x2: 64.2172,
    y2: 54.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaylighting);
export default __webpack_public_path__ + "static/media/daylighting.303f9e312ae191d95ab01d359395ed44.svg";
export { ForwardRef as ReactComponent };